import { useCallback } from 'react';

import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';

import { CONTACT_US_URL } from '#client/constants';

import { CANCEL_FLOW_TYPES, getCancelClickstreamProps, subscriptionContextPropType } from '../utils/cancelFlowConfig';

function SubscriptionCancelActions({ cancelFlowType, onConfirm, subscriptionContext }) {
  const handleContactCS = useCallback(() => {
    window.location.href = CONTACT_US_URL;
  }, []);

  return (
    <Stack
      gap={2}
      sx={{
        flexDirection: { xs: 'column', sm: 'row' },
        '& > *': { flex: 1 },
      }}
    >
      <Button
        variant="outlined"
        size="large"
        clickstreamProps={getCancelClickstreamProps(cancelFlowType, 'contactCs', subscriptionContext)}
        onClick={handleContactCS}
      >
        <FormattedMessage id="dashboard.subscriptionCancel.actions.contactCS" />
      </Button>
      <Button
        variant="contained"
        size="large"
        clickstreamProps={getCancelClickstreamProps(cancelFlowType, 'confirm', subscriptionContext)}
        onClick={onConfirm}
      >
        <FormattedMessage id="dashboard.subscriptionCancel.reason.continue" />
      </Button>
    </Stack>
  );
}

SubscriptionCancelActions.propTypes = {
  cancelFlowType: PropTypes.oneOf(Object.values(CANCEL_FLOW_TYPES)).isRequired,
  onConfirm: PropTypes.func.isRequired,
  subscriptionContext: subscriptionContextPropType,
};

export default SubscriptionCancelActions;
